import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { passwordLengthValidator, passwordsMatchValidator } from 'src/app/shared/validators';
import { NotificationService } from '../../../shared/services/notification.service';
import { ResetPasswordViewModel } from '../../auth-models';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  isBusy = false;
  token: string;
  id: string;

  @Input() loginUrl = '/auth/login';

  formGroup = new UntypedFormGroup(
    {
      password: new UntypedFormControl('', { validators: [Validators.required, passwordLengthValidator] }),
      confirmedPassword: new UntypedFormControl('', { validators: [Validators.required] }),
    },
    {
      updateOn: 'blur',
      validators: passwordsMatchValidator,
    }
  );

  inputType: 'text' | 'password' = 'password';
  inputTypePassCopy: 'text' | 'password' = 'password';

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.id = this.route.snapshot.queryParamMap.get('id');

    if (!this.token || !this.id) {
      // important parameters weren't provided, hence redirect user to login page
      this.routeToLoginPage();
    }
  }

  onSubmit() {
    const model = this.formGroup.value as ResetPasswordViewModel;
    model.token = this.token;
    model.id = this.id;

    if (model.password !== model.confirmedPassword) {
      this.notificationService.error('Password and Confirm Password do not match.');
      return;
    }

    this.isBusy = true;
    this.authService.resetPassword(model).subscribe(
      (response) => {
        this.isBusy = false;
        this.routeToLoginPage();
      },
      (error) => {
        this.notificationService.error(error?.error);
        this.isBusy = false;
      }
    );
  }

  routeToLoginPage() {
    this.router.navigateByUrl(this.loginUrl);
  }

  onRevealOrHide(isVisible: boolean) {
    if (isVisible) this.inputType = 'text';
    else this.inputType = 'password';
  }

  onRevealOrHideCopy(isVisible: boolean) {
    if (isVisible) this.inputTypePassCopy = 'text';
    else this.inputTypePassCopy = 'password';
  }
}
